import React from 'react'
import { Wrap } from './Styled'
import { Field } from 'redux-form'
import { RenderField } from 'components/Form'

/**
 * Fields (redux-form field list renderer)
 * Renders a list of redux-form fields from a config array. Each item becomes a
 * `<Field component={RenderField} />` that resolves to the correct input via `fieldsTyps`.
 *
 * **How it works**
 * - Pass `fields`: an array of field config objects (redux-form props + `component` type).
 * - Each field's `component` value (e.g. `"input"`, `"autoComplete"`) maps to `fieldsTyps` in `RenderField`.
 * - `csswrap` is forwarded to the styled `Wrap` container for layout.
 *
 * Used inside redux-form setups and via `fieldsTyps.fields` in form schemas.
 *
 * @param {Object} props
 * @param {Array<Object>} props.fields - Field configs. Each item needs `component` (type key) and redux-form props (`name`, `validate`, etc.).
 * @param {string} [props.csswrap] - CSS/layout class forwarded to `Wrap`.
 * @example
 * <Fields
 *   csswrap="form-grid"
 *   fields={[
 *     { name: 'email', component: 'input', placeholder: 'Email' },
 *     { name: 'role', component: 'autoComplete', options: roles },
 *   ]}
 * />
 * @example
 * // In fieldsTyps schema
 * { component: 'fields', fields: [{ name: 'name', component: 'input' }] }
 */
const Fields = (props) => {
    const { csswrap, fields } = props

    return (
        <Wrap csswrap={csswrap}>
            {fields.map((field, index) =>
                <Field
                    {...field}
                    key={index}
                    dynamicComponent={field.component}
                    component={RenderField}
                />
            )}
        </Wrap>
    )
}

export default Fields